exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#maintenance{margin:0 auto;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-48f3dbb6!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/Maintenance.vue
// module id = 880
// module chunks = 2